import React from 'react';
export default function Blog006() {
  return (
    <>
    <section>
    <article>
      <h2>6. 08-14-2022</h2>
      <h3>Tap to Flap Game!</h3>
      <p> Hello reader. <br />
        I am Eric Polley, currently on my 6th week of Web Development. I am currently focusing on Javascript by 
        creating tutorials based on the needs of my current self produced project. <br /><br />
        Today I took on a tutorial: 'Flappy Birds Game' by 'KnifeCircus'. I found a lot of value in learning a restart function, simulating gravity,
         and using a button to activate a character function like jumping. This knowledge can be transferred to transition animations upon 'onclick'.   
       <br />
       I have also gained a general understanding of creating a clickable-button layout. Using buttons and clickable actions are a big part of creating games and apps.
       I would like to work on a few more tutorials of the same subject to get a further understanding of DOM manipulation, Objects, and Arrays.
     <br />
     To conclude, I have finished a 'flappy-birds' game at its base core functionality. You can play
     the game now, click on the link below!
      </p> 
    </article>
   
    <h4>Links</h4>
    <br />
    <ul>
      <li>
        <a
          href="https://ericpolley.github.io/taptoflap/"
          title="Tap to Flap"
        >
          <strong><p>Tap to Flap Game!</p></strong></a
        >
      </li>
      <li>
        <a
          href="http://erpolley.com"
          title="Check out my website"
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>
  </>
  )
}
